import { isEmpty } from 'lodash';
import React from 'react';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';
import { useUser } from '../store/hooks/hooks';
import qs from 'query-string';
import CONSTANTS from '../constants/constant';

interface Props extends RouteProps {
  admin?: boolean;
  roles?: string[];
}

const redirectToLogin = (comProps: RouteComponentProps) => {
  return (
    <Redirect
      to={{
        pathname: '/login',
        state: { from: comProps.location },
      }}
    />
  );
};

const redirectToDriver = (comProps: RouteComponentProps) => {
  return (
    <Redirect
      to={{
        pathname: '/tai-xe',
        state: { from: comProps.location },
      }}
    />
  );
};

const redirectToProjectOne = (comProps: RouteComponentProps) => {
  return (
    <Redirect
      to={{
        pathname: '/projectone',
        state: { from: comProps.location },
      }}
    />
  );
};

const redirectToProfile = (comProps: RouteComponentProps) => {
  return (
    <Redirect
      to={{
        pathname: '/profile',
        state: { from: comProps.location },
      }}
    />
  );
};

function PrivateRoute(props: Props) {
  const { render, admin, ...rest } = props;
  const user = useUser();

  const renderRedirect = () => {
    const params: any = qs.parse(window.location.search);
    if (params.imei) {
      localStorage.setItem('imei', params.imei || '');
    }

    if (user.isLoggedIn()) {
      if (!props.path?.includes('/profile') && (user.raw_password === '999999' || user.secondary_password === '999999' ||
        user.third_password === '999999' || user.raw_password === user.secondary_password ||
        user.raw_password === user.third_password || user.secondary_password === user.third_password)) {
        return redirectToProfile;
      }
      const hasRole = props.roles?.some((role) => user.hasRole(role));
      if (isEmpty(props.roles) || hasRole) {
        return render;
      } else {
        if (user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DS_TAI_XE)) {
          return redirectToDriver;
        } else if (user.hasProject(CONSTANTS.PROJECTS.PROJECT_ONE)) {
          return redirectToProjectOne;
        }
        return redirectToProfile;
      }
    } else {
      return redirectToLogin;
    }
  };

  return <Route {...rest} render={renderRedirect()} />;
}

export default PrivateRoute;
